// :: Dependencies
import {
  auth,
  firestore,
  firestoreDb,
  storageRef,
  functions,
} from "@/config/firebase";
import { i18n } from "@/i18n";
import store from "@/store";
import { showMessage } from "@/services/MessageService";
export default {
  /**
   * Save the information of the independent works (abstracts) of the participants
   * @param {Object} participantAbst contains the eventID, and all the information required for registration
   * Used in UploadAbstract view in /views/Abstracts/UploadAbstract.vue
   */
  async uploadAbstract(participantAbst) {
    try {
      const profilePDF = await storageRef
        .child(
          `events/${participantAbst.eventID}/participants/${participantAbst.uid}/abstracts/pdfAbstrac${participantAbst.title}`
        )
        .putString(participantAbst.file, "data_url");
      const pdfURL = await profilePDF.ref.getDownloadURL();
      participantAbst.file = pdfURL;
      const abstractRef = await firestore("events")
        .doc(participantAbst.eventID)
        .collection("participants")
        .doc(participantAbst.uid)
        .collection("abstracts")
        .add({ ...participantAbst });

      await firestore("events")
        .doc(participantAbst.eventID)
        .collection("abstracts")
        .doc(abstractRef.id)
        .set(participantAbst);

      showMessage({
        title: i18n.global.t("abstract.solicitudSuccess.title"),
        message: `${i18n.global.t("abstract.solicitudSuccess.message")} ${
          participantAbst.eventName
        }`,
        type: "success",
      });
    } catch {
      showMessage({
        title: i18n.global.t("abstract.solicitudError.title"),
        message: i18n.global.t("abstract.solicitudError.message"),
        type: "error",
      });
    }
  },
  async validAbstractApply({ eventID, uid }) {
    const abstractsSnap = await firestore("events")
      .doc(eventID)
      .collection("participants")
      .doc(uid)
      .collection("abstracts")
      .get();
    const eventData = store.getters["user/eventData"];
    const today = new Date().getTime();
    if (eventData?.abstractSettings) {
      if (
        today >=
          eventData?.abstractSettings.uploadStartDate.toDate().getTime() &&
        today <= eventData?.abstractSettings.uploadEndDate.toDate().getTime() &&
        abstractsSnap.docs.length === 0
      )
        return true;
      else return false;
    } else return false;
  },
  /**
   * Get event information
   * Receives the event identifier as a parameter: eventID
   * Used in UploadAbstract view in /views/Abstracts/UploadAbstract.vue
   */
  async getEventAbstractSettings(eventID) {
    let setting;
    try {
      const eventSettings = await firestoreDb
        .collection("events")
        .doc(eventID)
        .collection("abstractSettings")
        .get();
      eventSettings.forEach((doc) => (setting = doc.data()));
      return setting;
    } catch (e) {
      showMessage({
        title: i18n.global.t("hotels.obtainHotelInfoError.title"),
        message: i18n.global.t("hotels.obtainHotelInfoError.message"),
        type: "error",
      });
      return null;
    }
  },
};
